<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card class="card" color="primary">
          <v-card-title class="font-weight-bold justify-center">Catálogo de armas</v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="end" align="center">
                <v-col cols="3">
                  <TextButton @click="openRegistroArmaDialog"> REGISTRAR ARMA NUEVA </TextButton>
                </v-col>
                <v-col cols="12">
                  <v-data-table class="primary" :headers="headers" :items="armas" :search="buscaArma" calculate-widths>
                    <template v-slot:[`item.estatus`]="{ item }">
                      <span class="text-body-2">{{ item.CatEstatus.title }}</span>
                    </template>
                    <template v-slot:[`item.opciones`]="{ item }">
                      <span class="d-flex align-center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton
                                class="mr-2"
                                variant="secondary"
                                icon="mdi-update"
                                @click="openEstatusArmaDialog(item)"
                              />
                            </span>
                          </template>
                          <span>Estatus arma</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton
                                class="mr-2"
                                variant="secondary"
                                icon="mdi-pencil"
                                @click="openEditarArmaDialog(item)"
                              />
                            </span>
                          </template>
                          <span>Editar arma</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton
                                variant="secondary"
                                icon="mdi-history"
                                @click="openHistorialArmasDialog(item)"
                              />
                            </span>
                          </template>
                          <span>Historial armas</span>
                        </v-tooltip>
                      </span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import TextButton from '../../../base/TextButton.vue'
import { DIALOG_TYPES } from '../../../../plugins/dialog-types'
import IconButton from '../../../base/IconButton.vue'

export default {
  components: {
    TextButton,
    IconButton,
  },

  data() {
    return {
      headers: [
        { text: 'Tipo', value: 'CatClase.CatTipo.title', width: '10%' },
        { text: 'Marca', value: 'CatModelo.CatMarca.title', width: '10%' },
        { text: 'Modelo', value: 'CatModelo.modelo', width: '5%' },
        { text: 'Folio', value: 'folio', width: '10%' },
        { text: 'Matrícula', value: 'matricula', width: '10%' },
        { text: 'No. económico', value: 'noEconomico', width: '10%' },
        { text: 'Armero', value: 'armeros', width: '10%' },
        { text: 'Fecha alta LOC', value: 'fechaAltaLoc', width: '10%' },
        { text: 'Estatus', value: 'estatus', width: '15%', sortable: false },
        { text: 'Opciones', value: 'opciones', align: 'right', sortable: false },
      ],
      selectedArma: null,
      buscaArma: '',
      DIALOG_TYPES,
    }
  },

  computed: {
    ...mapGetters('arma', {
      armas: 'getArmas',
    }),
  },

  methods: {
    ...mapActions('claseArma', ['fetchClasesArma']),
    ...mapActions('modeloArma', ['fetchModeloArmas']),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations('arma', ['SET_SELECTED_ARMA']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    openEstatusArmaDialog(arma) {
      this.SET_SELECTED_ARMA(arma)
      this.SET_DIALOG(DIALOG_TYPES.ESTATUS_ARMA_DIALOG_COMPONENT)
    },

    async openEditarArmaDialog(arma) {
      await this.fetchClasesArma(arma.CatClase.fk_idTipo)
      await this.fetchModeloArmas(arma.CatModelo.fk_idMarca)

      this.SET_SELECTED_ARMA(arma)
      this.SET_DIALOG(this.DIALOG_TYPES.EDITAR_ARMA_DIALOG_COMPONENT)
    },
    openRegistroArmaDialog() {
      this.SET_DIALOG(DIALOG_TYPES.RESGITRO_ARMA_NUEVA)
    },

    async openHistorialArmasDialog(arma) {
      try {
        this.SET_SELECTED_ARMA(arma)
        await this.$store.dispatch('armeria/fetchHistorialByArma', arma.idArma)
        this.SET_DIALOG({
          ...this.DIALOG_TYPES.HISTORIAL_ARMAS,
          props: {
            idArma: arma.idArma,
          },
        })
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('No fue posible cargar el historial del arma.')
      }
    },
  },
}
</script>
